<template>
  <section>
    <div class="row mb-4">
      <button :class="['btn', 'btn-secondary', {'active': 'phone' === cl}]" @click="setRT('phone')">  
        <i class="fas fa-phone icon"></i> 
      </button>
      <button :class="['btn', 'btn-secondary', {'active': 'tables' === cl}]" @click="setRT('tables')">
        <i class="fas fa-table icon"></i>
      </button>
      <button :class="['btn', 'btn-secondary', {'active': 'chat' === cl}]" @click="setRT('chat')">  
        <i class="fas fa-comment icon"></i> 
      </button>
      <!-- <button :class="['btn', 'btn-secondary', {'active': 'toggle' === cl}]" @click="setRT('toggle')">  
        <i class="fas fa-reply icon"></i> 
      </button> -->
    </div>

    <!-- Seção toggleRealtime -->
    <div class="row m-4" v-show="toggleRealtime">
      <div class="col-md-8">
        <TbFilaURA @open-modal-transf="handleOpenModalTransf"/>
        <ModalTransferencia ref="modalTransferencia" :valueClient="dadoClient"></ModalTransferencia>
        <TbFilaAtendimento @open-modal-transf="handleOpenModalTransf"/>
        <TbFilaAndamento @open-modal-transf="handleOpenModalTransf"/>
      </div>
      <div class="col-md-4 p-0">
        <TbFilaDetail class="m-2"/>
        <GraficoRespondids class="m-2"/>
      </div>
     
    </div>
      <div class="row">
        <div class="col-md-8"  v-show="toggleRealtime">
          <TbUsers ref="tbUsers"/>
        </div>
        <div class="col-md-4"  v-show="toggleRealtime">
          <GraficoOcupacaoAgent/>
      </div>

      <realtime-phone v-show="toggleChat" :connection="connection"/>
    </div>
  

    <!-- Seção toggleDashboard -->
    <div class="row" v-show="toggleDashboard">
      <RtmCallDetailsTable :conSocket="connection"></RtmCallDetailsTable>
      <RtmUsersDetailsTable :conSocket="connection"></RtmUsersDetailsTable>
      <br>
      <div class="col-md-12 tab-one-wrapper">
        <div class="card-status-center">
          <Group :queues="queues" @selection-changed="updateChartFilter"/>
        </div>
      </div>
      <ServiceLevelRealtime :filter="chartFilter"></ServiceLevelRealtime>
    </div>
  </section>
</template>


<script>
import TbUsers from "./components/TbUsers";
import GraficoRespondids from "./components/GraficoRespondids";
import GraficoOcupacaoAgent from "./components/GraficoOcupacaoAgent";
import TbFilaAtendimento from "./components/TbFilaAtendimento";
import RealtimePhone from './RealtimePhone.vue';
import TbFilaURA from "./components/TbFilaURA";
import TbFilaAndamento from "./components/TbFilaAndamento";
import TbFilaDetail from "./components/TbFilaDetail";
import ModalTransferencia from '../../components/newScreen/mensagem/ModalTransferencia.vue';
import RtmCallDetailsTable from "./components/RealtimeCallDetailsTable.vue";
import RtmUsersDetailsTable from "./components/RealtimeUsersDetailsTable.vue";
import ServiceLevelRealtime from "../charts/ServiceLevelRealtime.vue";
import Group from '../filters/Group.vue';
import { BIconFileEasel } from "bootstrap-vue";
import socketWpp from "./../../modules/realtime/service/service";

//const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
// const rtmPort = process.env.APP_PORT || 3003;
// const conSocket = parsedTelefone ? io.connect(`${location.protocol}//${location.hostname}:${rtmPort}/realtimeModule`) : { on: () => { }, emit: () => { } };

const isSSL = (location.hostname == 'localhost')? 'http': 'https';
const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
const noopSocket = { on() {}, emit() {}, off() {}, disconnect() {} };

export default {
  name: "RealtimeApp",
  data(){
    return{
      toggleRealtime: false,
      toggleDashboard: false,
      toggleChat: true,
      intervalId: '',
      cl: 'toggle',
      dadoClient: '',
      chartFilter: "*",
      queues: [],
      connection: noopSocket
    }
  },
  created(){
    this.connection = parsedTelefone
      ? io.connect(`${isSSL}://${location.hostname}:3003/realtimeModule`)
      : noopSocket;
    //if (this.cl == "toggle") {
      //this.intervalId = setInterval(() => {
        //this.toggleRealtime = !this.toggleRealtime;
        //this.toggleChat = !this.toggleChat;
      //}, 15000);
   // }
    this.fetchQueuesAndGroups();
  },
  mounted() {
    socketWpp.connect();
  },

  beforeDestroy() {
    socketWpp.emit('realtime:leave');
    socketWpp.disconnect();
    this.connection.disconnect();
  },
  methods:{
    handleOpenModalTransf(dado) {
      this.dadoClient = dado;
      this.$refs.modalTransferencia.openModal();
    },
    setRT(style) {
      // Resetar todas as propriedades
      this.toggleRealtime = false;
      this.toggleChat = false;
      this.toggleDashboard = false;

      // Ativar apenas a propriedade selecionada
      if (style === 'phone') {
        this.toggleDashboard = false;
        this.toggleRealtime = false;
        this.toggleChat = true;
      } else if (style === 'tables') {
        this.toggleRealtime = false;
        this.toggleChat = false;
        this.toggleDashboard = true;
      } else if (style === 'chat') {
        this.toggleDashboard = false;
        this.toggleChat = false;
        this.toggleRealtime = true;
      }
      // if (style == "toggle") {
      //   this.intervalId = setInterval(() => {
      //     this.toggleRealtime = !this.toggleRealtime;
      //     this.toggleChat = !this.toggleChat;
      //   }, 15000);
      // }
    },

    fetchQueuesAndGroups() {
      axios.get('/user/listQueueUser').then(({ data }) => {
        this.queues = data;
      });
    },
    updateChartFilter(newFilter) {
      this.chartFilter = newFilter;
    }
    
  },
  components: {TbFilaAtendimento, TbFilaURA, TbFilaAndamento, TbFilaDetail, GraficoOcupacaoAgent, GraficoRespondids, TbUsers, RealtimePhone, ModalTransferencia, RtmCallDetailsTable, RtmUsersDetailsTable, ServiceLevelRealtime, Group},
}
</script>

<style scoped>
.toogle-el{
  display:none;
}

.container-align {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>